// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3NMCq","resendInfoText":"OnGoingPaymentBox_resendInfoText__bwlY2"};